import React from 'react';

const MenuIcon  = ({ color = "#222222" }) => (
    <svg width="18" height="18" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 4.5H30V7.5H0V4.5ZM0 13.5H30V16.5H0V13.5ZM0 22.5H30V25.5H0V22.5Z" fill={color}/>
    </svg>
);

export default MenuIcon;
